import { render, staticRenderFns } from "./OrganizationDeletedMoreDropdown.vue?vue&type=template&id=1cc06d0b&scoped=true"
import script from "./OrganizationDeletedMoreDropdown.vue?vue&type=script&lang=js"
export * from "./OrganizationDeletedMoreDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc06d0b",
  null
  
)

export default component.exports